module.exports = __webpack_public_path__ + "static/media/location.2afa99eb.webp";